import type { ReactNode } from 'react';

/** Page title row used on every screen, Clockify style: title left, actions right. */
export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-2xl font-normal text-foreground">{title}</h1>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

/** Standard page body padding. */
export function Page({ children }: { children: ReactNode }) {
  return <div className="mx-auto w-full max-w-[1400px] p-4 sm:p-6">{children}</div>;
}
